export default "__VITE_ASSET__DwpG8$z0__"